// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteIcon_root__39V_z"};